// 1. 文档：.doc、.docx、.ppt、.pptx、.xls、.xlsx、.pdf；单个文档小于100MB
// 2. 图片： .jpg、.jpeg、.gif、.png、.bmp；单个图片小于10MB
// 3. 视频：.wmv、.mp4、.avi、.mov、；单个视频小于2GB
import { flutterDownloadH5Url, isTudoApp } from '@/utils/tudo'
import { isFeishu } from './feishu'
import { useRouter } from 'vue-router'
import { outFieldDownloadH5Url } from './outfield'
import { isOutFieldApp } from './outfield'
import { isSandsTalkNativeApp, nativeDownloadH5Url, sandsTalkVnNativeLauncherUrl } from './sandsTalkNative'
import { isSandsTalkMiddleEastApp, sandsTalkMiddleEastNativeLauncherUrl } from '@/utils/sandsTalkMEOutfiled'
import { branchManagerDownloadH5Url, isBranchManagerApp } from './sandsTalkBranchManager'
import { isWisdomRabbitApp, wisdomRabbitDownloadH5Url } from './sandsTalkSmartRabbit'
import { isSandsTalkBrMexApp, sandsTalkBrMexLauncherUrl } from './sandsTalkBRMXOutfiled'
import { driverDownloadH5Url, isCnDriverAppSource } from './sandsTalkCnDriverApp'
import { isSandsTalkMSFlutterApp, sandsTalkMyNativeLauncherUrl } from './sandsTalkMSFlutter'

const router = useRouter()

export const FileTypes = ['doc', 'docx', 'ppt', 'pptx', 'xls', 'xlsx', 'pdf']
export const FileSizeLimit = 100 * 1000 * 1000 * 8 // b
export const ImageTypes = ['jpg', 'jpeg', 'gif', 'png', 'bmp']
export const ImageSizeLimit = 10 * 1000 * 1000 * 8
export const VideoTypes = ['wmv', 'mp4', 'avi', 'mov']
export const VideoSizeLimit = 2 * 1000 * 1000 * 1000 * 8
export const ImageVideoTypes = ['jpg', 'jpeg', 'gif', 'png', 'bmp', 'wmv', 'mp4', 'avi', 'mov']

function isMediaType(fileName: string, types: string[]) {
  for (const value of types) {
    if (fileName.toLowerCase().endsWith(value)) {
      return true
    }
  }
  return false
}

export function isVideo(fileName?: string) {
  if (fileName == null || fileName.length === 0) return false
  return isMediaType(fileName, VideoTypes)
}
export function isImage(fileName?: string) {
  if (fileName == null || fileName.length === 0) return false
  return isMediaType(fileName, ImageTypes)
}
export function isFile(fileName?: string) {
  if (fileName == null || fileName.length === 0) return false
  return isMediaType(fileName, FileTypes)
}

export function getFileType(fileName?: string): string {
  if (fileName == null || fileName.length === 0) return ''
  if (isVideo(fileName)) return 'Video'
  if (isImage(fileName)) return 'Image'
  if (isFile(fileName)) return 'File'
  return ''
}

// 判断上传文件类型
export function getDocumentType(fileName?: string) {
  const fileNameType = fileName && fileName.split('.').pop()
  switch (fileNameType) {
    case 'ppt':
    case 'pptx':
      return require('@/assets/images/train/ppt.png')
    case 'doc':
    case 'docx':
      return require('@/assets/images/train/word.png')
    case 'xls':
    case 'xlsx':
      return require('@/assets/images/train/excel.png')
    case 'pdf':
      return require('@/assets/images/train/pdf.png')
    case 'jpg':
    case 'jpeg':
    case 'gif':
    case 'png':
    case 'bmp':
      return require('@/assets/images/train/photo.png')
    case '':
      return require('@/assets/images/train/pdf.png')
    default:
      return require('@/assets/images/train/link.png')
  }
}

// 文件的下载
export function downloadAttachment(attachment: any) {
  const SandsTalkUserInfo = JSON.parse(localStorage.getItem('SandsTalkUserInfo') || '{}')
  const u = navigator.userAgent
  let url = attachment.downLoadURL

  // 检查是否在微信环境中
  const isWeChat = /micromessenger/i.test(u)

  // 如果是微信环境且文件是 PDF，则截取 URL
  if (isWeChat && attachment.name.toLowerCase().endsWith('.pdf')) {
    const urlParts = new URL(url)
    url = `${urlParts.origin}${urlParts.pathname}?versionId=${urlParts.searchParams.get('versionId')}`
  }

  // 外场下载
  if (isOutFieldApp) {
    outFieldDownloadH5Url(url, attachment.name)
    return
  }

  // 司机App下载
  if (isCnDriverAppSource()) {
    driverDownloadH5Url(url, attachment.name)
    return
  }

  // 网点管家下载
  if (isBranchManagerApp) {
    branchManagerDownloadH5Url(url, attachment.name)
    return
  }

  // TudoApp 下载
  if (isTudoApp) {
    flutterDownloadH5Url(url)
    return
  }

  // 智慧兔下载
  if (isWisdomRabbitApp) {
    wisdomRabbitDownloadH5Url(url)
    return
  }

  // 泰国外场 下载
  if (isSandsTalkNativeApp && SandsTalkUserInfo.source === 'ThOutfield') {
    nativeDownloadH5Url(url)
    return
  }

  // 越南下载
  if (isSandsTalkNativeApp && SandsTalkUserInfo.source === 'vnOutfield') {
    sandsTalkVnNativeLauncherUrl(url)
    return
  }

  // 中东下载
  if (isSandsTalkMiddleEastApp) {
    sandsTalkMiddleEastNativeLauncherUrl(url, attachment.name)
    return
  }
  // 巴西和墨西哥 下载
  if (isSandsTalkBrMexApp) {
    sandsTalkBrMexLauncherUrl(url, attachment.name)
    return
  }

  // 马来下载
  if (isSandsTalkMSFlutterApp) {
    sandsTalkMyNativeLauncherUrl(url, attachment.name)
    return
  }

  const elLink = document.createElement('a')
  elLink.style.display = 'none'
  elLink.href = url
  elLink.setAttribute('download', attachment.name)
  elLink.setAttribute('target', 'downloadFile')
  document.body.appendChild(elLink)
  elLink.click()

  // 处理 Feishu 环境下的特殊行为
  if (isFeishu && !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
    router.go(-1)
  }

  URL.revokeObjectURL(elLink.href) // 释放 URL 对象
  document.body.removeChild(elLink)
}

// 分享到微信的缩略图获取

/**
 *
 * @param attachments 详情页附件数据
 * @param type 社区详情 帖子，文章，图册类型 1: 帖子 2：文章 3：图册  资讯详情： 传 0
 */
export function getWeChatThumbnail(attachments: any, type: number) {
  let previewUrl = `${location.origin}/web/wx_share_default.jpg`

  if (attachments && attachments.length > 0) {
    if (ImageTypes.includes(attachments[0].type)) {
      previewUrl = attachments[0].previewUrl
    }
  }

  return previewUrl
}
